import CheckPermission from '../../../hooks/CheckPermission';
import { Form, Formik } from 'formik'
import React, { useRef, useState } from 'react'
import { FaCheckDouble, FaWeightHanging } from 'react-icons/fa'
import CustomTable from '../../../shared/CustomTable'
import CustomButton from '../../../shared/CustomButton'
import ReusableModal from '../../../shared/ReuseableModal'
import {
  returnToVenderColumns,
  WriteOffItemColumns
} from '../../../constants/InverntoryConstants'
import { DeleteIcon, EditIcon } from '../../../utils/TableActionIcons'
import WriteOffForm from './WriteOffForm'
import SearchField from '../../../shared/SearchField'
import ReturnToVendorForm from './ReturnToVendorForm'
import { IoIosReturnLeft } from 'react-icons/io'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

function ReturnToVendor () {
  const { hasPermission } = CheckPermission();
  const { t } = useTranslation()
  const formikRef = useRef()
  const [openModal, setOpenModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [rowIndex, setRowIndex] = useState(-1)
  const navigate = useNavigate()

  const actionsTemplate = (row, col) => {
    return (
      <div className='flex justify-start gap-2 items-center'>
        {hasPermission('inventory', 'update') && (
          <EditIcon
            onClick={() => {
              setSelectedItem(row)
              setOpenModal(true)
              setRowIndex(col?.rowIndex)
            }}
          />
        )}
        {hasPermission('inventory', 'delete') && <DeleteIcon />}
      </div>
    )
  }

  const action = {
    header: t('Actions'),
    headerCellClass: '!bg-gray-200',
    body: actionsTemplate
  }
  const columns = [action, ...returnToVenderColumns(t)]

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        items: []
      }}
      onSubmit={values => console.log(values)}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <div className='flex justify-between items-center mt-4'>
            <SearchField placeholder='Search' className='w-full md:w-[300px]' />
            {hasPermission('inventory', 'create') && (
              <CustomButton
                type='button'
                onClick={() => {
                  navigate('/return-to-vendor')
                }}
                icon='pi pi-plus'
                label={t('CreateNewReturn')}
              />
            )}
          </div>
          <div className='mt-4'>
            <CustomTable columns={columns} data={values?.items} />
          </div>
          {/* <ReusableModal
            isVisible={openModal}
            position='top'
            title={t('NewReturn')}
            HeaderIcon={IoIosReturnLeft}
            onClose={() => {
              setOpenModal(false)
            }}
          >
            <ReturnToVendorForm
              selectedItem={selectedItem}
              setOpenModal={setOpenModal}
              setSelectedItem={setSelectedItem}
              rowIndex={rowIndex}
              setRowIndex={setRowIndex}
            />
          </ReusableModal> */}
        </Form>
      )}
    </Formik>
  )
}

export default ReturnToVendor
